// src/instrument.js
// Подключение Sentry для фронтенда (React + Vite).
// Импортируется ПЕРВОЙ строкой в src/main.jsx:  import "./instrument";

import * as Sentry from "@sentry/react";

// Инициализируем Sentry только в настоящем браузере.
// Smoke-тест прогоняет бандл в не-браузерном окружении, где нет браузерных API
// (например, addEventListener) — там Sentry пропускаем, иначе бандл падает при загрузке.
if (typeof globalThis.addEventListener === "function") {
  Sentry.init({
    dsn:
      import.meta.env.VITE_SENTRY_DSN ||
      "https://67393fa51873fd0b28fbc00821a8eacf@o4511602265227264.ingest.de.sentry.io/4511602287312976",
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_APP_VERSION || undefined,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Трейсинг
    tracesSampleRate: 0.2, // 20% транзакций хватает для картины; free-план не упирается в лимит
    tracePropagationTargets: ["localhost", /^https:\/\/bvlgvkov\.com\/api/],
    // Session Replay: только сессии с ошибками
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    // Отсекаем ожидаемый шум: (1) 401 при истёкшей сессии — apiFetch делает
    // тихий refresh или логин-редирект, это не баг; (2) провалы загрузки чанков
    // после деплоя — lazyPage сам перезагружает страницу. И то, и другое —
    // управляемые состояния, не нужны как алерты.
    ignoreErrors: [
      // Ожидаемое: протухший access-токен до тихого рефреша; окно рестарта бэка при деплое.
      /Request failed: 401/, 'Unauthorized',
      /Failed to update a ServiceWorker/,
      /Importing a module script failed/i,
      /Failed to fetch dynamically imported module/i,
      /Loading chunk \d+ failed/i,
      /Load failed/i,
      /ChunkLoadError/i,
      /NetworkError when attempting to fetch/i,
    ],
    beforeSend(event, hint) {
      const err = hint && hint.originalException;
      const msg = (err && (err.message || String(err))) || (event.message || '');
      // 401/403 из fetch — авторизационный поток, а не исключение приложения.
      if (/\b401\b|\b403\b|Unauthorized|Forbidden/i.test(msg)) return null;
      // Динамический импорт чанка (устаревший индекс после деплоя).
      if (/module script|dynamically imported|Loading chunk|ChunkLoadError/i.test(msg)) return null;
      // Шлюзовые коды: бэкенд перезапускается (деплой) или сеть отвалилась.
      // Это состояние инфраструктуры, а не баг кода — хук сам делает повтор,
      // а в Sentry такие события только маскируют настоящие ошибки.
      if (/failed 50[234]|\b50[234]\b|Failed to fetch|NetworkError|Load failed/i.test(msg)) return null;
      return event;
    },
  });
}